import { cloneElement, ReactElement, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

import styles from './Tooltip.module.css'

export interface TooltipProps {
  children: ReactElement
  label: string
  className?: string
}

const tooltipVariants = {
  hidden: {
    opacity: 0,
    y: -10
  },
  visible: {
    opacity: 1,
    y: 0
  }
}

export function Tooltip({ children, label, className }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div className="relative inline-block">
      {cloneElement(children, {
        onMouseEnter: () => setIsVisible(true),
        onMouseLeave: () => setIsVisible(false),
        onFocus: () => setIsVisible(true),
        onBlur: () => setIsVisible(false)
      })}

      <AnimatePresence>
        {isVisible && (
          <motion.div
            variants={tooltipVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className={`${styles.tooltip} ${
              className || ''
            } absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-50`}
          >
            {label}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
